import { RouterManager } from '@aclass/admin/managers';
import { QuestionnaireStory } from '@aclass/admin/storage/actions';
import { IAdminState, IQuestionnaireModuleState } from '@aclass/admin/storage/states';
import { BaseResolver } from '@aclass/core/resolvers/base.resolver';
import { NgRedux } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable()
export class QuestionnaireShowResultStateResolver extends BaseResolver {

    static STOP_EVENT_NAME = 'stop:questionnaire-show-result';

    private id: string;

    constructor(
        private ngRdx: NgRedux<IAdminState>,
        private routerManager: RouterManager
    ) {
        super();
        this.resolver = this.ngRdx.select<IQuestionnaireModuleState['showResultPageRecordId']>(['questionnaireModule', 'showResultPageRecordId']).pipe(
            filter(v => v === this.id)
        );
        this.employee = this.routerManager.onRejectNavigation(QuestionnaireShowResultStateResolver.STOP_EVENT_NAME);
    }

    /**
     * @inheritDoc
     */
    beforeResolve(route: ActivatedRouteSnapshot): void {
        // id = brand-locale-id
        this.id = route.params.id;
        this.ngRdx.dispatch(QuestionnaireStory.dryRunShowResultPage(this.id));
    }
}
